import axiosIns from 'utils/axios'
let epmcore ='EPM-CORE-SERVICE'


function formatChildren(e){
  let tree = []
  e.forEach(item=>{
    tree.push(Object.assign(item,{
      label:item.name,
      key:item.id
    }))
  })
  return tree
}

export function formatTreeAndPerson(e){
  let tree = []
  e.forEach((item)=>{
    if(!item.mpttVOList && !item.data.employeeVOList){
      tree.push({
        label:item.data.name,
        key:item.id || item.data.id,
        rootId:item.rootId,
        companyId:item.data.companyId,
        mpttRootId:item.data.mpttRootId,
        principal:item.data.principal,
        children:[],
        disabled: checkDisabled(item)
      })
    } else if(item.mpttVOList && !item.data.employeeVOList){
      tree.push({
        label:item.data.name,
        key:item.id || item.data.id,
        rootId:item.rootId,
        companyId:item.data.companyId,
        mpttRootId:item.data.mpttRootId,
        principal:item.data.principal,
        children:formatTreeAndPerson(item.mpttVOList),
        disabled: checkDisabled(item)
      })
    } else if(!item.mpttVOList && item.data.employeeVOList){
      tree.push({
        label:item.data.name,
        key:item.data.id,
        rootId:item.rootId,
        companyId:item.data.companyId,
        mpttRootId:item.data.mpttRootId,
        principal:item.data.principal,
        children:formatChildren(item.data.employeeVOList),
        disabled: checkDisabled(item)
      })
    } else if(item.mpttVOList && item.data.employeeVOList){
      tree.push({
        label:item.data.name,
        key:item.id,
        rootId:item.rootId,
        companyId:item.data.companyId,
        mpttRootId:item.data.mpttRootId,
        principal:item.data.principal,
        children:formatTreeAndPerson(item.mpttVOList).concat(formatChildren(item.data.employeeVOList)),
        disabled: checkDisabled(item)
      })
    }
  })
  return tree
}

function checkDisabled (e) {
  // if (e) return true
  // else return false
  return false
}

// 获取会议列表
export function getMeetingList (params) {
    return axiosIns({
      url: `/api/pc/meeting/page`,
      owner: epmcore,
      method: 'get',
      params
    })
}

export function meetingDelete (id) {
  return axiosIns({
    url: `/api/pc/meeting/delete/${id}`,
    owner: epmcore,
    method: 'delete'
  })
}

export function meetingUpdate (data) {
  return axiosIns({
    url: `/api/pc/meeting/update`,
    owner: epmcore,
    method: 'put',
    data
  })
}

export function listProject () {
  return axiosIns({
    url: `/api/pc/project/listProject`,
    owner: epmcore,
    method: 'get'
  })
}


export function getProject (params) {
  return axiosIns({
    url: `/api/pc/project/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function projectVersion (params) {
  return axiosIns({
    url: `/api/pc/projectVersion/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function getTreeAndPerson () {
  return axiosIns({
    url: `/api/pc/organization/listDetail`,
    method: 'get',
    owner: epmcore
  })
}

export function meetingadd (data) {
  return axiosIns({
    url: `/api/pc/meeting/add`,
    method: 'post',
    owner: epmcore,
    data
  })
}

export function meetingGetDetail (id) {
  return axiosIns({
    url: `/api/pc/meeting/getDetail/${id}`,
    method: 'get',
    owner: epmcore
  })
}










// WEBPACK FOOTER //
// ./src/views/meeting-manage/api.js